module.exports = __webpack_public_path__ + "static/jud-2f1e4ce0bca8af493481c0383878efd5.jpg";